import { render, staticRenderFns } from "./NavigatorBottomBarLinkChat.vue?vue&type=template&id=2720aa52"
import script from "./NavigatorBottomBarLinkChat.vue?vue&type=script&lang=js"
export * from "./NavigatorBottomBarLinkChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports